import type { z } from 'zod';

import { CandidateSchema } from './candidate';

export const SavedCandidateFavoriteCandidateSchema = CandidateSchema.pick({
  addressCity: true,
  addressCountry: true,
  addressState: true,
  availabilityStatus: true,
  badges: true,
  barredLocations: true,
  businessTitle: true,
  calculatedDisplayName: true,
  calculatedFirstName: true,
  calendar: true,
  candidateHeader: true,
  candidateSummary: true,
  certifications: true,
  currencyType: true,
  degrees: true,
  displayHighHourlyRate: true,
  displayLowHourlyRate: true,
  displayWeeklyRate: true,
  homeOffice: true,
  hasRate: true,
  hoursPerDay: true,
  id: true,
  industries: true,
  isAvailableToConsult: true,
  isInterviewableFromALT: true,
  isSpotlightedLawyer: true,
  isViewOnly: true,
  languages: true,
  lawDegreeSchools: true,
  lawFirms: true,
  minWeeklyHoursPerPosition: true,
  primaryFocusArea: true,
  primaryPracticeArea: true,
  profileImageKey: true,
  profileImageName: true,
  pronouns: true,
  publicRefId: true,
  searchableByClient: true,
  weeklyAvailability: true,
  yearsOfExperience: true,
});
export type SavedCandidateFavoriteCandidate = z.infer<
  typeof SavedCandidateFavoriteCandidateSchema
>;
